"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMethods = void 0;
var react_1 = require("react");
var useOrderAndSplitPaymentMethodsByGEO_1 = __importDefault(require("./useOrderAndSplitPaymentMethodsByGEO"));
var useMethods = function (_a) {
    var type = _a.type, paymentSettings = _a.paymentSettings, methods = _a.methods;
    var orderAndSplitPaymentMethodsByGEO = (0, useOrderAndSplitPaymentMethodsByGEO_1.default)(paymentSettings);
    return (0, react_1.useMemo)(function () {
        if (type === 'cashout')
            return {
                paymentsWithLabelsSetup: methods,
                paymentsWithLabelsAdditional: [],
            };
        var orderedMethods = orderAndSplitPaymentMethodsByGEO(methods);
        return {
            paymentsWithLabelsSetup: orderedMethods['withSetup'],
            paymentsWithLabelsAdditional: orderedMethods['additional'],
        };
    }, [orderAndSplitPaymentMethodsByGEO, methods, type]);
};
exports.useMethods = useMethods;
